<template>
  <b-card
    body-class="p-0"
    class="border-0">
    <div class="w-100">
      <!--
        KEEP EXACT THIS TABULATION!
        This is not wrong, even though it looks weird
      -->
      <pre
        class="w-100 min-h-100px bg-gray-900 text-white font-size-sm py-6 m-0 px-6"
        :class="embed ? 'rounded-bottom' : 'rounded'">
<code
class="p-0 bg-gray-900 text-white"
v-html="history" />
</pre>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'Terminal',
  props: {
    history: {
      type: undefined,
      default: () => '',
    },
    embed: {
      type: Boolean,
      default: () => false
    }
  },
}
</script>
